import styled from "@emotion/styled";

export const Container = styled("div")`
  margin: 0 auto;
  width: min(96%, 1500px);
`;

Container.displayName = "Container"
